import { useState } from 'react';
import AvatarMatchingGame from '../components/AvatarMatchingGame';
import MythologyQuiz from '../components/MythologyQuiz';
import GodsAndGoddesses from '../components/GodsAndGoddesses';
import EpicTimeline from '../components/EpicTimeline';
import JigsawPuzzle from '../components/JigsawPuzzle';
import KrishnaButterBall from '../components/KrishnaButterBall';
import Meta from '../components/Meta';
// Removed imports for mythology games that are now in Games.js

export default function Puzzle() {
  const [activeGame, setActiveGame] = useState('avatars');
  
  // Schema markup for structured data
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "VEDA Mythological Puzzles",
    "description": "Educational mythological puzzles for kids based on Indian epics and deities.",
    "url": "https://vedamerchandise.com/puzzles",
    "publisher": {
      "@type": "Organization",
      "name": "VEDA Merchandise",
      "logo": {
        "@type": "ImageObject",
        "url": "https://vedamerchandise.com/logo.svg"
      }
    }
  };

  return (
    <>
      <Meta 
        title="VEDA Mythological Puzzles - Educational Puzzles for Kids"
        description="Educational mythological puzzles for kids based on Indian epics and deities."
        keywords="mythological puzzles, Indian mythology puzzles, educational puzzles, kids puzzles, VEDA puzzles, Ramayana puzzles, Mahabharata puzzles"
        author="VEDA Merchandise"
        ogTitle="VEDA Mythological Puzzles - Educational Puzzles for Kids"
        ogDescription="Educational mythological puzzles for kids based on Indian epics and deities."
        ogImage="https://vedamerchandise.com/puzzles-preview.jpg"
        ogUrl="https://vedamerchandise.com/puzzles"
        ogType="website"
        twitterCard="summary_large_image"
        twitterTitle="VEDA Mythological Puzzles - Educational Puzzles for Kids"
        twitterDescription="Educational mythological puzzles for kids based on Indian epics and deities."
        twitterImage="https://vedamerchandise.com/puzzles-preview.jpg"
        robots="index, follow"
        canonicalUrl="https://vedamerchandise.com/puzzles"
        schemaMarkup={schemaMarkup}
      />
      <div className="min-h-screen ">
        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 py-8">
          <div className="text-center mb-8">
            <h1 className="text-5xl font-bold mb-4 fredoka">
              <span className="text-red-500">Mythological</span>{' '}
              <span className="text-yellow-500">Puzzles</span>
            </h1>
            
            <p className="text-xl text-gray-700 mb-8">
              Fun & Educational Games for Kids
            </p>
          </div>

          {/* Game Selector - Removed mythology games */}
          <div className="flex flex-wrap justify-center gap-4 mb-8">
            <div className="bg-white rounded-full p-1 shadow-lg">
              <button
                onClick={() => setActiveGame('avatars')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors ${
                  activeGame === 'avatars' 
                    ? 'bg-red-500 text-white' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Match the Avatars
              </button>
            </div>
            
            <div className="bg-white rounded-full p-1 shadow-lg">
              <button
                onClick={() => setActiveGame('jigsaw')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors ${
                  activeGame === 'jigsaw' 
                    ? 'bg-red-500 text-white' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Jigsaw Puzzle
              </button>
            </div>

            <div className="bg-white rounded-full p-1 shadow-lg">
              <button
                onClick={() => setActiveGame('quiz')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors ${
                  activeGame === 'quiz' 
                    ? 'bg-red-500 text-white' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Mythology Quiz
              </button>
            </div>
            
            <div className="bg-white rounded-full p-1 shadow-lg">
              <button
                onClick={() => setActiveGame('gods')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors ${
                  activeGame === 'gods' 
                    ? 'bg-red-500 text-white' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Gods & Goddesses
              </button>
            </div>
            
            <div className="bg-white rounded-full p-1 shadow-lg">
              <button
                onClick={() => setActiveGame('timeline')}
                className={`px-6 py-3 rounded-full font-semibold transition-colors ${
                  activeGame === 'timeline' 
                    ? 'bg-red-500 text-white' 
                    : 'text-gray-600 hover:bg-gray-100'
                }`}
              >
                Epic Timeline
              </button>
            </div>
            
            
          </div>

          {/* Game Content - Removed mythology games */}
          <div className="bg-white rounded-2xl shadow-xl p-4 md:p-8 mb-12">
            {activeGame === 'avatars' && <AvatarMatchingGame />}
            {activeGame === 'jigsaw' && <JigsawPuzzle />}
            {activeGame === 'quiz' && <MythologyQuiz />}
            {activeGame === 'gods' && <GodsAndGoddesses />}
            {activeGame === 'timeline' && <EpicTimeline />}
          </div>

          {/* Game Descriptions - Removed descriptions for mythology games */}
          <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-12">
            <div className="bg-gradient-to-br from-red-50 to-yellow-50 rounded-2xl p-6 shadow-md">
              <h3 className="text-2xl font-bold text-red-600 mb-3 fredoka">Match the Avatars</h3>
              <p className="text-gray-700 mb-4">
                Flip cards to find matching pairs of Lord Vishnu's avatars! 
                Each match reveals an exciting story about the avatar.
              </p>
              <ul className="text-gray-600 list-disc pl-5 space-y-1">
                <li>Improves memory and concentration</li>
                <li>Learn about the 10 avatars of Vishnu</li>
                <li>Engaging stories with each match</li>
                <li>Beautiful animations and sound effects</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-red-50 to-yellow-50 rounded-2xl p-6 shadow-md">
              <h3 className="text-2xl font-bold text-red-600 mb-3 fredoka">Mythology Quiz</h3>
              <p className="text-gray-700 mb-4">
                Test your knowledge of Indian mythology with our fun quiz game!
                Answer questions about gods, goddesses, and epic stories.
              </p>
              <ul className="text-gray-600 list-disc pl-5 space-y-1">
                <li>Multiple choice questions</li>
                <li>Instant feedback with explanations</li>
                <li>Progress tracking</li>
                <li>Educational and entertaining</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-red-50 to-yellow-50 rounded-2xl p-6 shadow-md">
              <h3 className="text-2xl font-bold text-red-600 mb-3 fredoka">Gods & Goddesses</h3>
              <p className="text-gray-700 mb-4">
                Learn about the attributes of various gods and goddesses in Indian mythology.
                Match deities with their weapons, vehicles, and roles.
              </p>
              <ul className="text-gray-600 list-disc pl-5 space-y-1">
                <li>Learn about divine attributes</li>
                <li>Multiple game modes</li>
                <li>Colorful and engaging interface</li>
                <li>Build cultural knowledge</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-red-50 to-yellow-50 rounded-2xl p-6 shadow-md">
              <h3 className="text-2xl font-bold text-red-600 mb-3 fredoka">Epic Timeline</h3>
              <p className="text-gray-700 mb-4">
                Arrange events from the Mahabharata or Ramayana in the correct chronological order.
                Drag and drop events to test your knowledge of these epic stories.
              </p>
              <ul className="text-gray-600 list-disc pl-5 space-y-1">
                <li>Drag-and-drop gameplay</li>
                <li>Two epic options: Ramayana & Mahabharata</li>
                <li>Instant feedback with story snippets</li>
                <li>Improve understanding of epic chronology</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-red-50 to-yellow-50 rounded-2xl p-6 shadow-md">
              <h3 className="text-2xl font-bold text-red-600 mb-3 fredoka">Jigsaw Puzzle</h3>
              <p className="text-gray-700 mb-4">
                Assemble complete images from smaller pieces in this challenging jigsaw puzzle game.
                Multiple difficulty levels and beautiful mythological images to choose from.
              </p>
              <ul className="text-gray-600 list-disc pl-5 space-y-1">
                <li>Multiple difficulty levels</li>
                <li>Various mythological images</li>
                <li>Track moves and time</li>
                <li>Improves spatial reasoning</li>
              </ul>
            </div>
            
          
          </div>

          {/* Educational Value */}
          <div className="bg-gradient-to-r from-red-500 to-red-600 rounded-2xl p-8 text-white text-center shadow-xl mb-12">
            <h2 className="text-3xl font-bold mb-4 fredoka">Why Learn Mythology?</h2>
            <p className="text-xl max-w-3xl mx-auto">
              Indian mythology is filled with wisdom, values, and fascinating stories that have been passed down for generations. 
              Our games make learning about these stories fun and engaging for children!
            </p>
          </div>
        </main>
      </div>
    </>
  );
}